import { render, staticRenderFns } from "./JEllipsis.vue?vue&type=template&id=24287a54"
import script from "./JEllipsis.vue?vue&type=script&lang=js"
export * from "./JEllipsis.vue?vue&type=script&lang=js"
import style0 from "./JEllipsis.vue?vue&type=style&index=0&id=24287a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports